import { ERentTime } from '../types';

export const DEFAULT_LONGTERM_RENT_OPTION = ERentTime.NotDaily;
export const LONGTERM_RENT_OPTIONS = [DEFAULT_LONGTERM_RENT_OPTION, ERentTime.FromYear, ERentTime.FewMonths];
